export enum ActionTypes {
  FETCH_DESTINATIONS_REQUEST = 'dataSync/FETCH_DESTINATIONS_REQUEST',
  FETCH_DESTINATIONS_RESPONSE = 'dataSync/FETCH_DESTINATIONS_RESPONSE',
  FETCH_DESTINATIONS_ERROR = 'dataSync/FETCH_DESTINATIONS_ERROR',
}
